import {Brick, registerBrick} from 'olympe';
import {defaultFilter} from '../components/dialogs/filters/DrawerFiltersContent.jsx';
import isEqual from 'lodash/isEqual';

/**
 * Check if current filters are different from default
 */
export default class AreFiltersApplied extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} currentFilters
     * @param {function(boolean)} setResult
     */
    update($, [currentFilters], [setResult]) {
        const areEqual = isEqual(currentFilters, defaultFilter);
        setResult(!areEqual);
    }
}

registerBrick('0193ba76657f765dd374', AreFiltersApplied);
